import { Rating as FsrsRating, State as FsrsState, createEmptyCard, fsrs } from "ts-fsrs";
import type { Card as FsrsCard } from "ts-fsrs";
import type { Rating } from "./types";

export const FSRS_SCHEDULER_VERSION = "TS-FSRS-5.4.2";

export interface SchedulerInput {
  state: string;
  stability: number;
  difficulty: number;
  reps: number;
  lapses: number;
  due_at?: string;
  last_review?: string | null;
  scheduler_version?: string;
}

const fsrsScheduler = fsrs({ request_retention: 0.9 });

function toFsrsRating(rating: Rating) {
  return ({ 1: FsrsRating.Again, 2: FsrsRating.Hard, 3: FsrsRating.Good, 4: FsrsRating.Easy } as const)[rating];
}

function fromFsrsState(state: FsrsState) {
  if (state === FsrsState.New) return "new";
  if (state === FsrsState.Review) return "review";
  return "learning";
}

function toFsrsState(state: string) {
  if (state === "review") return FsrsState.Review;
  if (state === "learning") return FsrsState.Learning;
  return FsrsState.New;
}

function cardToFsrs(card: SchedulerInput, now: Date): FsrsCard {
  if (card.scheduler_version !== FSRS_SCHEDULER_VERSION) return createEmptyCard(now);
  return {
    due: new Date(card.due_at ?? now),
    stability: card.stability || 0,
    difficulty: card.difficulty || 0,
    elapsed_days: 0,
    scheduled_days: 0,
    learning_steps: 0,
    reps: card.reps || 0,
    lapses: card.lapses || 0,
    state: toFsrsState(card.state),
    last_review: card.last_review ? new Date(card.last_review) : undefined,
  };
}

export function scheduleFsrsReview(card: SchedulerInput, rating: Rating, now = new Date()) {
  const next = fsrsScheduler.next(cardToFsrs(card, now), now, toFsrsRating(rating)).card;
  return {
    state: fromFsrsState(next.state),
    stability: next.stability,
    difficulty: next.difficulty,
    reps: next.reps,
    lapses: next.lapses,
    dueAt: next.due,
    schedulerVersion: FSRS_SCHEDULER_VERSION,
  };
}
